import { render, staticRenderFns } from "./shoptempleteconfig.vue?vue&type=template&id=9908ada0&"
import script from "./shoptempleteconfig.vue?vue&type=script&lang=js&"
export * from "./shoptempleteconfig.vue?vue&type=script&lang=js&"
import style0 from "./shoptempleteconfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports